import { Constraints } from ".."
import User from "./user"

class LocalUser<T> extends User<T> {

  constructor(userInfo: T) {
    super(userInfo)
    this.createStream = async () => null
  }
  createStream: (streamName: string, constraints: Partial<Constraints>) => Promise<MediaStream | null>
  
  async changeConstraints(newConstraints: Partial<Constraints>, streamName: string) {
    const tracks = []
    if (newConstraints.audio === true || newConstraints.video === true) {
      const mediaStream = await this.createStream(streamName, newConstraints)
      if (!mediaStream) return false
      
      tracks.push(...mediaStream.getTracks())
    }

    const stream = this.initStream(streamName)
    return await stream.produce(tracks, newConstraints)
  }

  consume(answer: any, streamName: string) {
    const stream = this.streams[streamName]
    if (!stream) return
    stream.consume(answer)
  }
}

export default LocalUser